import { useLoadScript } from '../../../hooks/useLoadScript';

// API: https://learn.microsoft.com/en-us/microsoftteams/platform/concepts/build-and-test/share-to-teams-from-web-apps
const MSTeamsShareButton = ({ url, body }: { url: string; body: string }) => {
  useLoadScript('https://teams.microsoft.com/share/launcher.js');

  return (
    <div
      key={url}
      className="teams-share-button"
      data-href={url}
      data-icon-px-size="32"
      data-msg-text={body}
    ></div>
  );
};

export default MSTeamsShareButton;
